import { useLenis } from "lenis/react";
import { BRAND, CONTACT, NAV_LINKS } from "@/data/site";

export const Footer = () => {
  const lenis = useLenis();

  const goTo = (href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="relative bg-onyx text-ivory pt-16 pb-9 border-t border-ivory/10"
    >
      <div className="mx-auto max-w-shell px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-8 pb-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <span className="font-display text-2xl leading-none">G&amp;F</span>
              <span className="h-6 w-px bg-ivory/20" />
              <span className="label-xs text-mist leading-[1.5]">
                Luxury Retail
                <br />
                Environments
              </span>
            </div>
            <p className="mt-7 max-w-xs text-sm font-light leading-relaxed text-ivory/55">
              Luxury retail environments. Delivered and installed with precision.
            </p>
          </div>

          <nav className="md:col-span-3">
            <div className="label-xs text-mist">Index</div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => goTo(l.href)}
                    className="text-sm text-ivory/70 hover:text-champagne transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-2">
            <div className="label-xs text-mist">Office</div>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li>{BRAND.location}</li>
              <li>Canada</li>
              <li>
                <a
                  href={`tel:${CONTACT.phoneTel}`}
                  className="hover:text-champagne transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="label-xs text-mist">Enquiries</div>
            <ul className="mt-5 space-y-3 text-sm text-ivory/70">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-champagne transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-champagne transition-colors"
                >
                  Instagram
                </a>
              </li>
              <li className="text-ivory/45">{CONTACT.note}</li>
            </ul>
          </div>
        </div>

        <div className="pt-7 border-t border-ivory/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="label-xs text-slate">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </div>
          <div className="label-xs text-slate">{BRAND.corridor}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
